import { POST } from "./utils";

export const createSession = async (token: string, uid: string) => {
    return await POST("/session", { token, uid });
};

export const getCoreAppCustomAuthToken = async () => {
    return await POST("/query/jwt", {});
};

export const logout = async () => {
    // Handle logout endpoint that returns text "Ok" instead of JSON
    const response = await fetch("/query/logout", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
    });

    // 403 means already logged out, which is a successful logout
    if (!response.ok && response.status !== 403) {
        throw new Error(response.statusText || "Failed to logout");
    }

    // Return the text response instead of trying to parse as JSON
    // For 403, just return "Ok" since user is already logged out
    return response.status === 403 ? "Ok" : response.text();
};
